import React from "react";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import classNames from "classnames";

import { Loader } from "../../Loaders/Loader/Loader";
import { EmptyState } from "../../EmptyState/EmptyState";
import "./EnhancedTable.scss";

export const EnhancedTable = ({
    className,
    children,
    commandBar,
    count,
    isLoading
}) => {
    if(isLoading) {
        return <Loader style={{ height: "70vh" }} />;
    }

    if(!count || count < 0) {
        return <EmptyState />;
    }

    return (
        <div className={classNames("table-wrapper", className)}>
            <TableContainer className={"table-wrapper-container"}>
                <Table
                    stickyHeader
                    aria-label="sticky table"
                >
                    { children }
                </Table>
            </TableContainer>

            { commandBar && commandBar}
        </div>
    );
};
